import { HOST_API_KEY } from "../globalConfig"

type ApiMethods = "GET" | "POST" | "DELETE" | "PATCH" | "PUT"

var modules = {
  USER_AUTH: "user",
  USER: "users",
  AWS: "aws",
  ADDITIONAL_SERVICE: "additional-service",
  TICKET: "ticket",
  ARRIVAL_DEPARTURE: "arrival-departure",
  CLEANER_APP: "cleanerapp",
  CLEANING_COMPANIES: "cleaningCompanies",
  FORM: "forms",
  OWNERS: "owners",
  PDF_GENERATION: "pdf-generation",
  MAINTENANCE: "maintenance",
  CLEANS: "cleans",
}

export const ROUTES = {
  login: "API for Inital Login",
  getUserDetails: "API for User Details",
  uploadImages: "API to Upload Images",
  getProperty: "Get List of Properties with Code and Name",
  getaArrivalDepartureCountv2: "A&D Counter API",
  getPostArrivalDepartureTicketv2: "AnD Table New API",
  getBookingNotes: "Bookig Notes API for Current and Next Booking",
  cleansCountv2: "Cleans Counter API",
  getCleanTicketsv2: "Cleans Table New API",
  getMaintananceDashboardCountv2: "Maintenance Counter API",
  getMaintainceTicketv2: "Maintenance Table New API",
  readTicket: "Mark Ticket as Read for AnD, Maintenance & Guest Request (Not Cleans)",
  getAllComments: "Comments API for Maintenance",
  postComments: "Update Comments API for Maintenance",
  postUpdateMaintenance: "Update API for Details Form & Modal Form in Maintenance",
  getAccounts: "Settings > Profile > Get Profile Information", // Deprecated
  updateAccount: "Settings > Profile > Update Profile Information", // Deprecated
  postSecurity: "Settings > Security > Change Password API",
  cleanDetails: "Get Cleans Details API",
  ownerBanners: "Get Images for owner properties",
  propertyCleanCompany: "Get Cleaning Company Dropdown API",
  addNote: "Add Notes for Cleans Details Page",
  deleteNote: "Delete Note from Cleans Details Page",
  getANDCurrentBookingDetails: "Get Arrival Departure Details Page 1st Accordion API",
  getANDStatusForm: "Get Arrival Departure Details Page 2nd Accordion API",
  getInternalEmployees: "Get All Internal Employees",
  getArrivalDepartureFormValueTicketDetails: "Old A&D Form API. Please remove this crap future developer",
  getTicketGuestDetails: "Maintenance Details Page Guest Details Accordion Data API",
  getServices: "Get List of Services for Maintenance in Details Page. Common API",
  getCompanyList: "Get List of Company for Maintenance in Details Page",
  getCompanyUserList: "Get List of Company tagged to User for Maintenance in Details Page",
  postFormByKeyId: "Get v1 Dynamic Maintenance Form // @deprecated",
  postMaintainceTicketAssign: "Assign Tickets as per Dropdown in Maintenance Details Page",
  getEmployeesv2: "Get List of Employee based on Company ID / Service Type (Cleans or Maintenance) / Company Type (Internal / External)",
  getCurrentOwnersDetails: "Get Details of Current Owner in Accounts Tab",
  updateCurrentOwnersDetails: "Get Details of Current Owner in Accounts Tab",
  postArrivalDepartureFormSubmission: "arrival-depature-form-submission",
  getPdfForArrivalDepartureForm: "getPdfForArrivalDepartureForm",
  getPropertyReservationTimeline: "/get_propert-reservations/",
  createMaintenanceTicket: "/maintenance/create-ticket",
  maintenanaceTicketRequest: "/maintenance-request/ticket-details",
  postMaintenanceFormSubmission: "maintenance-form-submission",
  getAvailCalendar: "/availability-calendar",
  getPdfForMaintenanceForm: "getPdfForMaintenanceForm",
  cleansTicketRequest: "/cleans/ticket-details",
  createCleansTicket: `/create-ticket`,
  postCleansFormSubmission: "cleans-form-submission",
  getPdfForCleansForm: "getPdfForCleansForm",
  getCompanyListv2: "company-list",
}

export const API_END_POINT: Record<ApiMethods, Record<string, string>> = {
  GET: {
    // Common Module
    [ROUTES.getUserDetails]: `${HOST_API_KEY}${modules.USER}/userDetails`,
    [ROUTES.getInternalEmployees]: `${HOST_API_KEY}${modules.OWNERS}/owner-internal-employees `,
    [ROUTES.getServices]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/services`,

    // AnD Module
    [ROUTES.getAllComments]: `${HOST_API_KEY}${modules.TICKET}/comments`,
    [ROUTES.getANDCurrentBookingDetails]: `${HOST_API_KEY}${modules.TICKET}/arrival-departure-inner`,
    [ROUTES.getANDStatusForm]: `${HOST_API_KEY}${modules.TICKET}/arrival-departure-inner/ticket-assign-form`,
    [ROUTES.getArrivalDepartureFormValueTicketDetails]: `${HOST_API_KEY}${modules.TICKET}/arrival-depature-ticketDetails`,

    // Cleans Module
    [ROUTES.ownerBanners]: `${HOST_API_KEY}${modules.OWNERS}/owner/property/images`,
    [ROUTES.cleanDetails]: `${HOST_API_KEY}${modules.CLEANER_APP}/clean`,
    [ROUTES.propertyCleanCompany]: `${HOST_API_KEY}${modules.CLEANER_APP}/property-clean-company`,
    [ROUTES.getCompanyList]: `${HOST_API_KEY}${modules.TICKET}/company_list`,
    [ROUTES.getCompanyUserList]: `${HOST_API_KEY}${modules.TICKET}/company_user_list`,

    [ROUTES.cleansTicketRequest]: `${HOST_API_KEY}${modules.CLEANS}/ticket_details`,

    // Maintenance Module
    [ROUTES.getTicketGuestDetails]: `${HOST_API_KEY}${modules.TICKET}/ticket_guest_details`,

    [ROUTES.getPropertyReservationTimeline]: `${HOST_API_KEY}${modules.MAINTENANCE}/get_property_reservations`,
    [ROUTES.maintenanaceTicketRequest]: `${HOST_API_KEY}${modules.TICKET}/maintenance/ticket_details`,

    // Account Profile Module
    [ROUTES.getCurrentOwnersDetails]: `${HOST_API_KEY}${modules.OWNERS}/owner`, // Append Owner's ID
    [ROUTES.getPdfForArrivalDepartureForm]: `${HOST_API_KEY}${modules.PDF_GENERATION}/arrival-depature-ticketDetails_pdf`,

    [ROUTES.getPdfForMaintenanceForm]: `${HOST_API_KEY}${modules.PDF_GENERATION}/maintenance/ticket_details_pdf`,
    [ROUTES.getPdfForCleansForm]: `${HOST_API_KEY}${modules.PDF_GENERATION}/cleans_ticket_details_pdf`,
  },
  POST: {
    // Login Module
    [ROUTES.login]: `${HOST_API_KEY}${modules?.USER_AUTH}/login`,

    // Common Module
    [ROUTES.uploadImages]: `${HOST_API_KEY}${modules.AWS}/image-aws`,
    [ROUTES.getEmployeesv2]: `${HOST_API_KEY}${modules.USER}/v2/employees`,
    [ROUTES.getProperty]: `${HOST_API_KEY}${modules.OWNERS}/list-owner-properties`,
    [ROUTES.getCompanyListv2]: `${HOST_API_KEY}${modules.CLEANING_COMPANIES}/v2/company-list`,

    // AnD Module
    [ROUTES.getaArrivalDepartureCountv2]: `${HOST_API_KEY}${modules.TICKET}/${modules.ARRIVAL_DEPARTURE}/ticket_count_v2`,
    [ROUTES.getPostArrivalDepartureTicketv2]: `${HOST_API_KEY}${modules.TICKET}/arrival-departure/ticket_v2`,
    [ROUTES.getBookingNotes]: `${HOST_API_KEY}notes/booking-notes`,

    // Cleans Module
    [ROUTES.cleansCountv2]: `${HOST_API_KEY}${modules.CLEANER_APP}/cleans_count_v2`,
    [ROUTES.getCleanTicketsv2]: `${HOST_API_KEY}${modules.CLEANER_APP}/get_cleans_v2`,
    [ROUTES.addNote]: `${HOST_API_KEY}${modules.CLEANER_APP}/add_note`,
    [ROUTES.deleteNote]: `${HOST_API_KEY}${modules.CLEANER_APP}/notes/delete`,

    [ROUTES.createCleansTicket]: `${HOST_API_KEY}${modules.CLEANS}/create_ticket`,
    [ROUTES.postCleansFormSubmission]: `${HOST_API_KEY}${modules.CLEANS}/cleans-form-submission`,

    // Maintenance Module
    [ROUTES.getMaintananceDashboardCountv2]: `${HOST_API_KEY}${modules.TICKET}/maintanance_dashboard_count_v2`,
    [ROUTES.getMaintainceTicketv2]: `${HOST_API_KEY}${modules.TICKET}/ticket_v2`,
    [ROUTES.readTicket]: `${HOST_API_KEY}${modules.TICKET}/mark_read`,
    [ROUTES.postFormByKeyId]: `${HOST_API_KEY}${modules.FORM}/getFromById`,
    [ROUTES.postMaintainceTicketAssign]: `${HOST_API_KEY}${modules.TICKET}/ticket_assign`,
    [ROUTES.createMaintenanceTicket]: `${HOST_API_KEY}${modules.TICKET}/maintenance/create_ticket`,
    [ROUTES.postMaintenanceFormSubmission]: `${HOST_API_KEY}${modules.FORM}/maintenance-form-submission`,

    // Maintenance Quick Modal Module
    [ROUTES.postComments]: `${HOST_API_KEY}${modules.TICKET}/comments`,
    [ROUTES.postUpdateMaintenance]: `${HOST_API_KEY}${modules.TICKET}/maintenance/update_ticket`,

    // Account Profile Module
    [ROUTES.postSecurity]: `${HOST_API_KEY}${modules.USER}/security`,
    [ROUTES.updateCurrentOwnersDetails]: `${HOST_API_KEY}${modules.OWNERS}/edit-owner`,

    [ROUTES.postArrivalDepartureFormSubmission]: `${HOST_API_KEY}${modules.FORM}/arrival-depature-form-submission`,

    [ROUTES.getAvailCalendar]: `${HOST_API_KEY}property_reservationDetails/availability-calendar`,
  },
  PATCH: {
    // Account Profile Module
    [ROUTES.updateAccount]: `${HOST_API_KEY}${modules.USER}/account`,
  },
  DELETE: {},
  PUT: {},
}

export default API_END_POINT
